import { render, staticRenderFns } from "./Academy_RES.vue?vue&type=template&id=11b30f18"
import script from "./Academy_RES.vue?vue&type=script&lang=js"
export * from "./Academy_RES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports